import { Decimal } from 'decimal.js';
import { IBWFormula } from '../../database/schema.js';
const IBW_CONFIG = {
    DEVINE: {
        male: { base: 50, perInch: 2.3 },
        female: { base: 45.5, perInch: 2.3 },
    },
    ROBINSON: {
        male: { base: 52, perInch: 1.9 },
        female: { base: 49, perInch: 1.7 },
    },
    MILLER: {
        male: { base: 56.2, perInch: 1.41 },
        female: { base: 53.1, perInch: 1.36 },
    },
};
export function calculateDecimalAIBW(height, weight, sex, precision = 4, method) {
    if (!Number.isFinite(height) || height <= 0 || !Number.isFinite(weight) || weight <= 0 || !method || !sex) {
        return 0;
    }
    const h = new Decimal(height);
    const w = new Decimal(weight);
    const inchesOver5Feet = h.div(2.54).sub(60);
    const ibw = getIBWDecimal(inchesOver5Feet, sex, method);
    let result = ibw;
    if (w.gt(ibw)) {
        result = ibw.add(new Decimal('0.4').mul(w.sub(ibw)));
    }
    return result.toDecimalPlaces(precision).toNumber();
}
function getIBWDecimal(inchesOver5Feet, sex, method) {
    if (!method || !sex)
        return Decimal('0');
    const { base, perInch } = IBW_CONFIG[method][sex];
    return new Decimal(base).add(new Decimal(perInch).mul(inchesOver5Feet));
}
//# sourceMappingURL=aibw.js.map